module.exports = function(store) {
  return function(next) {
    return function(action) {
      console.log(action);
      return next(action);
    };
  };
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3dvcmsvc3JjL3N0YXRlL0xvZ2dlck1pZGRsZXdhcmUuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3dvcmsvc3JjL3N0YXRlL0xvZ2dlck1pZGRsZXdhcmUuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLFNBQUMsS0FBRDtTQUFXLFNBQUMsSUFBRDtXQUFVLFNBQUMsTUFBRDtNQUNyQyxPQUFPLENBQUMsR0FBUixDQUFZLE1BQVo7YUFDQSxJQUFBLENBQUssTUFBTDtJQUZxQztFQUFWO0FBQVgifQ==
